import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import StarsIcons from "../StarsIcons";

import styles from "./Stars.scss";

const cx = classnames.bind(styles);

const Stars = ({
  className,
  imageLink,
  imgClassName,
  baseUrl,
  atiCode,
  ...rest
}) => (
  <div className={cx("stars", className)}>
    <StarsIcons
      {...rest}
      imageLink={imageLink}
      imgClassName={imgClassName}
      baseUrl={baseUrl}
      atiCode={atiCode}
    />
  </div>
);

Stars.defaultProps = {
  baseUrl: "ati.su",
};

Stars.propTypes = {
  imageLink: PropTypes.string,
  atiCode: PropTypes.string,
  className: PropTypes.string,
  imgClassName: PropTypes.string,
  baseUrl: PropTypes.string,
};

export default Stars;
